import React, { FC, PropsWithChildren } from 'react';

import { Filmoscope } from '@/scenarios/legacy-player/components/Filmoscope/Filmoscope';

import { PlayerApiError } from '../../types/instance';
import { PlayerConfig } from '../../types/config';

interface Props {
    config: PlayerConfig;
    useYasp?: boolean; // only for Filmoscope
    useSDKConfig?: boolean;
    onLoadingError?: (error: PlayerApiError) => void;
}

export const PlayerInstance: FC<PropsWithChildren<Props>> = ({
    children,
    config,
    useYasp,
    useSDKConfig,
    onLoadingError,
}) => (
    <Filmoscope
        config={config}
        useYasp={useYasp}
        useSDKConfig={useSDKConfig}
        onLoadingError={onLoadingError}
    >
        {children}
    </Filmoscope>
);
